import { render, staticRenderFns } from "./MerchantFlowModal.vue?vue&type=template&id=c71be96c&scoped=true"
import script from "./MerchantFlowModal.vue?vue&type=script&lang=js"
export * from "./MerchantFlowModal.vue?vue&type=script&lang=js"
import style0 from "./MerchantFlowModal.vue?vue&type=style&index=0&id=c71be96c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71be96c",
  null
  
)

export default component.exports